// extracted by css-extract-rspack-plugin
export default {"root":"dh_TS"};